module.exports = __webpack_public_path__ + "img/login_left.1cde7a92.png";